import styled from 'styled-components'

export const Text = styled.span`
    display: flex;
    align-items: center;
    gap: 8px;
`

export const ButtonAIWrapper = styled.button`
    border-radius: 8px;
    font-weight: 500;
    padding: 0 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s;
    white-space: nowrap;
    position: relative;
    overflow: hidden;
    outline: none !important;
    background: linear-gradient(90deg, #e0369b 0%, #c006e9 100%);
    border: none;
    height: 40px;
    cursor: pointer;
    ${Text} {
        color: #fff;
    }
    &:hover,
    &:focus,
    &:active {
        background: linear-gradient(90deg, rgba(224, 54, 155, 0.8) 0%, rgba(192, 6, 233, 0.8) 100%);
    }
`
